import { API } from '../../../../api';
import { axiosInstance } from '../../../../utils/fetcher';

const CancelToken = axiosInstance.CancelToken;

let getLocationListEffectCancelToken = () => {};
export const getLocationListEffect = (data) => {
  getLocationListEffectCancelToken();
  return axiosInstance.request({
    url: `${API.PROCUREMENT}/GetLocationSearch`,
    method: 'GET',
    params: data,
    cancelToken: new CancelToken(function executor(c) {
      getLocationListEffectCancelToken = c;
    }),
  });
};

export const saveUpdateLocationEffect = (data) => {
  return axiosInstance.request({
    url: `${API.PROCUREMENT}/SaveUpdateLocation`,
    method: 'POST',
    data,
  });
};

export const getPortlistProcurementEffects = (data) => {
  return axiosInstance.request({
    url: `${API.PROCUREMENT}/GetPortList`,
    method: 'GET',
    params: data,
  });
};

export const deleteProcurementLocationEffects = (params) => {
  return axiosInstance.request({
    url: `${API.PROCUREMENT}/DeleteLocation`,
    method: 'delete',
    data: params,
  });
};

export const getDownloadLocationLinkEffects = () => {
  return axiosInstance.request({
    url: `${API.PROCUREMENT}/GetLocationDownloadLink`,
    method: 'GET',
  });
};

export const getAddLocationListEffect = (data) => {
  return axiosInstance.request({
    url: `${API.PROCUREMENT}/GetLocationSearch`,
    method: 'GET',
    params: data,
  });
};

export const getExtractDataFileEffect = (data) => {
  return axiosInstance.request({
    url: `${API.PROCUREMENT}/ExtractDataFile`,
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data,
  });
};

export const saveUpdateLocationProcurementEffect = (data) => {
  return axiosInstance.request({
    url: `${API.PROCUREMENT}/SaveUpdateLocation`,
    method: 'POST',
    data,
  });
};
